<script>
import { h } from 'vue';

import DpDropdown from '../dropdown/DpDropdown.vue';
import { NAV_TYPE_TABS, NAV_TYPES } from './config';
import DpNavHeader from './DpNavHeader.vue';
import DpNavItem from './DpNavItem.vue';

export default {
  name: 'DpNav',

  components: {
    DpNavItem,
    DpNavHeader,
    DpDropdown,
  },

  props: {
    borderBottom: {
      required: false,
      type: Boolean,
      default: false,
    },

    borderTop: {
      required: false,
      type: Boolean,
      default: false,
    },

    /**
     * [
     *    { text: 'A link', href: 'https://znanylekarz.pl' },
     *    { type: 'header', text: 'Some header' },
     *    { type: 'dropdown', text: 'Some dropdown' },
     *    { text: 'Router link', to: { name: 'profile' } }
     * ]
     */
    items: {
      required: false,
      type: Array,
      default: () => ([]),
    },

    /**
     * @values tabs, pills, vertical
     */
    type: {
      required: false,
      type: String,
      default: NAV_TYPE_TABS,
      validator: (type) => NAV_TYPES.includes(type),
    },

    fill: {
      required: false,
      type: Boolean,
      default: false,
    },

    justified: {
      required: false,
      type: Boolean,
      default: false,
    },

    responsive: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    navClasses() {
      const classes = [
        'nav',
        `nav-${this.type}`,
      ];

      if (this.borderBottom && this.type === NAV_TYPE_TABS) {
        classes.push(`nav-tabs-border-bottom`);
      }

      if (this.borderTop && this.type === NAV_TYPE_TABS) {
        classes.push(`nav-tabs-border-top`);
      }

      if (this.justified) {
        classes.push('nav-justified');
      }

      if (this.fill) {
        classes.push('nav-fill');
      }

      return classes;
    },
  },

  methods: {
    renderContent(navDefaultSlot) {
      if (typeof navDefaultSlot === 'function' && navDefaultSlot() !== undefined) {
        return navDefaultSlot();
      }

      return this.items.map(({ type, ...item }) => {
        if (type === 'header') {
          return h(
            DpNavHeader,
            {
              ...item,
            },
          );
        }

        if (type === 'dropdown') {
          return h(
            DpDropdown,
            {
              ...item,
              tag: 'li',
            },
            {
              toggle: () => item.toggle,
            },
          );
        }

        return h(
          DpNavItem,
          {
            ...item,
          },
        );
      });
    },

    renderNav(navDefaultSlot) {
      return h(
        'ul',
        {
          class: this.navClasses,
        },
        {
          default: () => this.renderContent(navDefaultSlot),
        },
      );
    },

    renderResponsiveNav(navDefaultSlot) {
      return h(
        'div',
        {
          class: 'nav-responsive',
        },
        {
          default: () => ([this.renderNav(navDefaultSlot)]),
        },
      );
    },
  },

  render() {
    /* @slot Default slot, put nav item components here */
    const navDefaultSlot = this.$slots.default;

    if (this.responsive) {
      return this.renderResponsiveNav(navDefaultSlot);
    }

    return this.renderNav(navDefaultSlot);
  },
};
</script>
